import type { ComponentType, FC } from "react";
import React from "react";

export type WithNoDataBaseProps = {
  data?: unknown[];
  isLoading?: boolean;
  isFetched?: boolean;
};

export function withNoData<
  FullProps extends WithNoDataBaseProps,
  NoDataProps extends WithNoDataBaseProps,
>(
  Component: ComponentType<FullProps>,
  NoData: ComponentType<NoDataProps>
): FC<FullProps> {
  return (props: FullProps) => {
    const { data, isLoading } = props;

    if (data?.length === 0 && !isLoading) {
      const noDataProps = props as unknown as NoDataProps;
      return <NoData {...noDataProps} />;
    }

    return <Component {...props} />;
  };
}
export default withNoData;
